module.exports = __webpack_public_path__ + "static/media/t05kz.13742fc2.pdf";